<template>
  <div v-if="active" class="modal modal-v2" :class="{'is-active': active }">
    <div class="modal-background"></div>
      <div class="modal-card" :style="widthModal" :class="{'resetPasword': isResetPassword}">
        <div class="color-container border-radious-top">
          <div class="modal-card-title" v-if="!isResetPassword">
            <div class="title-container ">
              <span>{{ titleModal }}</span>
              <i class="fas fa-times pointer" @click.prevent="cancel" />
            </div>
            <div class="divider" />
            <div v-if="optionalText && !isConfirm" class="text-aling text-description">
              <span>{{ optionalText }}</span>
            </div>
            <div v-if="optionalText && isConfirm" class="text-aling-center text-description">
              <span>{{ optionalText }}</span>
            </div>
          </div>
        </div>
        <section class="modal-card-body" v-if="hasBodyContent">
          <div v-if="isOverflow" class="isOverflow"><slot /></div>
          <div v-else class="modal-inner-wrapper">
            <i v-show="showScrollUp" class="fas fa-chevron-up scroll-indicator scroll-indicator--top" />
            <div class="modal-inner" ref="modalInner" @scroll="_onInnerScroll">
              <slot />
            </div>
            <i v-show="showScrollDown" class="fas fa-chevron-down scroll-indicator scroll-indicator--bottom" />
          </div>
        </section>

        <footer class="color-container footer-container border-radious-bottom">
          <slot name="footer"/>
          <button
            v-if="!isMessage && !withoutCancel"
            class="button is-dark is-outlined px-6"
            @click.prevent="cancel"
            :disabled="isLoading"
          >
            <span>Cancelar</span>
            <span class="icon is-small" v-if="isIcon">
              <i class="far fa-times-circle"></i>
            </span>
          </button>

          <div :class="actionCenter ? 'actionsCenter':'actions'">
            <button
              v-if="!isMessage && !isConfirm && !withoutAction"
              :class="['button', actionColorClass, isLoading ? 'is-loading' : '']"
              @click="hdlOnClick"
              :disabled="isLoading || disabled"
            >
              <span>{{textSave}}</span>
              <span class="icon is-small" v-if="isIcon">
                <i class="far fa-check-circle"></i>
              </span>
            </button>
            <button
              v-if="isMessage && !isConfirm"
              class="button is-success center px-6"
              @click="cancel"
              :disabled="isLoading"
            >
              <span>Continuar</span>
              <span class="icon is-small" v-if="isIcon">
                <i class="far fa-check-circle"></i>
              </span>
            </button>
            <button
              v-if="!isMessage && isConfirm"
              :class="['button', actionColorClass, 'right', isLoading ? 'is-loading' : '']"
              @click="accept"
              :disabled="isLoading"
            >
              <span>{{textSave}}</span>
            </button>
            <button
              v-if="textAction && !withoutAction"
              :class="['button', actionColorClass, isLoading ? 'is-loading' : '']"
              @click="otherAction"
              :disabled="isLoading"
            >
              <span>{{ textAction || 'Aceptar' }}</span>
              <span class="icon is-small" v-if="isIcon">
                <i class="far fa-check-circle"></i>
              </span>
            </button>
          </div>
        </footer>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    isMessage: {
      // Flag para bloquear la acción de continuar o guardar
      type: Boolean,
      default: false
    },
    titleModal: {
      type: String,
      default: ''
    },
    optionalText: {
      type: String,
      default: ''
    },
    widthModal: {
      type: String,
      default: ''
    },
    textSave: {
      type: String,
      default: 'Guardar'
    },
    isConfirm: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    },
    withoutAction: {
      type: Boolean,
      default: false
    },
    isOverflow: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    withoutCancel: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    textAction: {
      type: String,
      default: ''
    },
    actionCenter: {
      type: Boolean,
      default: false
    },
    isResetPassword: {
      type: Boolean,
      default: false
    },
    actionColor: {
      type: String,
      default: 'green',
      validator: (v) => ['green', 'red'].includes(v)
    }
  },
  data () {
    return {
      showScrollUp: false,
      showScrollDown: false
    }
  },
  computed: {
    isLoading () {
      return this.loading || this.loader
    },
    actionColorClass () {
      return this.actionColor === 'red' ? 'is-danger' : 'is-success'
    },
    hasBodyContent () {
      return !!this.$slots.default
    }
  },
  watch: {
    active (val) {
      document.documentElement.classList.toggle('is-clipped', val)
    }
  },
  mounted () {
    if (this.active) document.documentElement.classList.add('is-clipped')
    window.addEventListener('keydown', this.handleEscape)
    this.$nextTick(() => this._checkScroll())
  },
  updated () {
    this._checkScroll()
  },
  beforeDestroy () {
    document.documentElement.classList.remove('is-clipped')
    window.removeEventListener('keydown', this.handleEscape)
  },
  methods: {
    _checkScroll () {
      const inner = this.$refs.modalInner
      if (!inner) return
      this.showScrollUp = inner.scrollTop > 0
      this.showScrollDown = inner.scrollTop + inner.clientHeight < inner.scrollHeight - 2
    },
    _onInnerScroll (e) {
      const el = e.target
      this.showScrollUp = el.scrollTop > 0
      this.showScrollDown = el.scrollTop + el.clientHeight < el.scrollHeight - 2
    },
    handleEscape (e) {
      if (e.key === 'Escape' && this.active && !this.isLoading) this.cancel()
    },
    cancel () {
      this.$emit('cancel')
    },
    hdlOnClick () {
      this.$emit('hdlOnClick')
    },
    accept () {
      this.$emit('accept')
    },
    otherAction () {
      this.$emit('otherAction')
    }
  }
}
</script>
